import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import themesJS from "./themes.js";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: themesJS
    }
  },
  icons: {
    iconfont: "fa"
  }
};

export default new Vuetify(opts);
